import isElementGlobal from './is-element-global';
import hasGlobals from './has-globals';
import hasSameGlobal from './has-same-global';
import isElementDetached from './is-element-detached';
import isLocaleUnAwareGlobalSource from './is-locale-unaware-global-source';
import isChildOfGlobal from './is-child-of-global';

export default {
  isElementGlobal,
  hasGlobals,
  hasSameGlobal,
  isElementDetached,
  isLocaleUnAwareGlobalSource,
  isChildOfGlobal,
};
